// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardLayout_layout__VZmlp {
  position: relative;
  height: 100vh;
  min-height: 100vh;
  background: var(--bg-color);
  background-size: cover;
  overflow: auto;
}
.DashboardLayout_layout__VZmlp .DashboardLayout_content__2dEED {
  max-width: 100%;
  width: 100%;
  display: flex;
  position: relative;
}
.DashboardLayout_layout__VZmlp .DashboardLayout_content__2dEED .DashboardLayout_rightContainer__b-qIG {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
@media (max-width: 780px) {
  .DashboardLayout_layout__VZmlp {
    background-image: unset;
  }
  .DashboardLayout_layout__VZmlp .DashboardLayout_content__2dEED {
    display: block;
  }
  .DashboardLayout_layout__VZmlp .DashboardLayout_content__2dEED .DashboardLayout_rightContainer__b-qIG {
    padding-bottom: 48px;
  }
}

@media (min-width: 780px) {
  .DashboardLayout_backdrop__s6Axn {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/DashboardLayout/DashboardLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACN;AAGE;EArBF;IAsBI,uBAAA;EAAF;EACE;IACE,cAAA;EACJ;EACI;IACE,oBAAA;EACN;AACF;;AAIA;EACE;IACE,aAAA;EADF;AACF","sourcesContent":[".layout {\n  position: relative;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--bg-color);\n  background-size: cover;\n  overflow: auto;\n\n  .content {\n    max-width: 100%;\n    width: 100%;\n    display: flex;\n    position: relative;\n\n    .rightContainer {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n    }\n  }\n\n  @media (max-width: 780px) {\n    background-image: unset;\n    .content {\n      display: block;\n\n      .rightContainer {\n        padding-bottom: 48px;\n      }\n    }\n  }\n}\n\n@media (min-width: 780px) {\n  .backdrop {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `DashboardLayout_layout__VZmlp`,
	"content": `DashboardLayout_content__2dEED`,
	"rightContainer": `DashboardLayout_rightContainer__b-qIG`,
	"backdrop": `DashboardLayout_backdrop__s6Axn`
};
export default ___CSS_LOADER_EXPORT___;
